import React from 'react'
import ReactDOM from 'react-dom'
import createReactClass from 'create-react-class'



var ProductListItemHeader = createReactClass({

	render: function() {
		return (
			<div className={this.props.className} id={this.props.id}>
				{this.props.children}
			</div>
		);
	}
});

export default ProductListItemHeader;
